import { HTMLProps, memo, useCallback, useMemo, useState } from 'react';
import cx from 'classnames';
import ReactCalendar from 'react-calendar';

import { ChevronDownIcon } from 'components/Icon';

import styles from './Calendar.module.scss';

export type CalendarProps = Pick<HTMLProps<HTMLDivElement>, 'className'> & {
  defaultValue?: Date;
  onChange?(value: Date): void;
};

const Calendar = ({ className, defaultValue = new Date(), onChange }: CalendarProps): JSX.Element => {
  const [activeStartDate, setActiveStartDate] = useState<Date>(defaultValue);
  const [value, setValue] = useState<Date>(defaultValue);

  const handleOnChange = useCallback(
    (newValue: Date) => {
      setValue(newValue);

      onChange?.(newValue);
    },
    [onChange]
  );

  const handleOnChangeActiveStartDate = useCallback(({ activeStartDate: newActiveStartDate }) => {
    setActiveStartDate(newActiveStartDate);
  }, []);

  return (
    <div className={cx(styles.container, className)}>
      <ReactCalendar
        view="month"
        calendarType="ISO 8601"
        minDate={useMemo(() => new Date(), [])}
        activeStartDate={activeStartDate}
        selectRange={false}
        allowPartialRange={false}
        prev2Label={null}
        next2Label={null}
        prevLabel={<ChevronDownIcon className={styles.left} />}
        nextLabel={<ChevronDownIcon className={styles.right} />}
        value={value}
        onChange={handleOnChange}
        onActiveStartDateChange={handleOnChangeActiveStartDate}
      />
    </div>
  );
};

const memoizedCalendar = memo(Calendar);

export default memoizedCalendar;
